import React from 'react';
import ReactDOM from 'react-dom/client';

// Initialize AWS Amplify before anything else
import './lib/amplifyConfig';

// Import your main CSS file (where @tailwind directives are)
import './index.css';

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
